import { render, staticRenderFns } from "./dbViewEdit.vue?vue&type=template&id=6f4f254e&scoped=true&"
import script from "./dbViewEdit.vue?vue&type=script&lang=js&"
export * from "./dbViewEdit.vue?vue&type=script&lang=js&"
import style0 from "./dbViewEdit.vue?vue&type=style&index=0&id=6f4f254e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f254e",
  null
  
)

export default component.exports